import { render, staticRenderFns } from "./ManualMpsStatusUpdate.vue?vue&type=template&id=2b366e21"
import script from "./ManualMpsStatusUpdate.vue?vue&type=script&lang=js"
export * from "./ManualMpsStatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports